<script lang="ts">
	import type { MarkdownOptions, Renderers } from '@magidoc/plugin-svelte-marked';
	import type { Tokens } from 'marked';
	import { onMount } from 'svelte';
	import { InlineTokens } from '../../../../features/newsletter-generation/components/Mardown/InlineTokens';
	import { Txt } from '../../../Txt';
	import { getMarkdownSafetyContext } from '../../utils/getMarkdownSafetyContext/getMarkdownSafetyContext';
	import { MarkdownInlineTokens } from '../MarkdownInlineTokens';

	interface Props {
		token: Tokens.Table;
	}

	let { token }: Props = $props();
	export const options: MarkdownOptions | undefined = undefined;
	export const renderers: Renderers | undefined = undefined;

	// The newsletter inline renderer passes link hrefs through untouched, so
	// untrusted sources use the Markdown one, which checks them.
	const CellTokens = getMarkdownSafetyContext()?.untrusted ? MarkdownInlineTokens : InlineTokens;

	let ref: HTMLTableElement | null = $state(null);

	onMount(() => {
		if (ref?.parentElement) {
			ref.parentElement.style.overflowX = 'scroll';
		}
	});
</script>

<table class="mx-auto" bind:this={ref}>
	<thead>
		<tr>
			{#each token.header as header}
				{#if header.tokens}
					<th class="border-1 border p-2"
						><Txt component="div" variant="label3">
							<CellTokens tokens={header.tokens} {options} {renderers} />
						</Txt></th
					>
				{/if}
			{/each}
		</tr>
	</thead>
	<tbody>
		<!-- eslint-disable-next-line @typescript-eslint/no-unused-vars -->
		{#each token.rows as _, i}
			<tr>
				{#each token.rows[i] as cell}
					{#if cell.tokens}
						<td class="border-1 border p-2 text-center">
							<Txt component="div" variant="body2">
								<CellTokens tokens={cell.tokens} {options} {renderers} />
							</Txt>
						</td>
					{/if}
				{/each}
			</tr>
		{/each}
	</tbody>
</table>
